import {
  SET_ADD_LOCATION,
  SET_LOCATIONS,
  FETCH_LOCATIONS_START,
  FETCH_LOCATIONS_SUCCESS,
  FETCH_LOCATIONS_FAILURE,
  ADD_LOCATION_START,
  ADD_LOCATION_SUCCESS,
  ADD_LOCATION_FAILURE,
  INITIAL_LOCATIONS,
  SET_CURRENT_LOCATION,
  SET_EDIT_LOCATION,
  FETCH_LOCATIONS_LIST_START,
  FETCH_LOCATIONS_LIST_SUCCESS,
  FETCH_LOCATIONS_LIST_FAILURE,
} from './LocationTypes';

const initialState = {
  locations: [],
  addNewLocation: false,
  loading: false,
  error: null,
  isAddingLocation: false,
  isFetchingLocationsList: false,
  locationsList: [],
  isEditLocation: false,
  currentLocation: null,
};

// eslint-disable-next-line default-param-last
const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_LOCATIONS:
      return {
        ...initialState,
      };
    case SET_ADD_LOCATION:
      return {
        ...state,
        addNewLocation: action.payload,
      };
    case ADD_LOCATION_START:
      return {
        ...state,
        isAddingLocation: true,
      };
    case ADD_LOCATION_SUCCESS:
      return {
        ...state,
        isAddingLocation: false,
      };
    case ADD_LOCATION_FAILURE:
      return {
        ...state,
        isAddingLocation: false,
        error: action.payload,
      };
    case SET_LOCATIONS:
      return {
        ...state,
        locations: action.payload,
      };
    case FETCH_LOCATIONS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        locations: action.payload,
        error: null,
      };
    case FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case FETCH_LOCATIONS_LIST_START:
      return {
        ...state,
        isFetchingLocationsList: true,
        error: null,
      };
    case FETCH_LOCATIONS_LIST_SUCCESS:
      return {
        ...state,
        isFetchingLocationsList: false,
        locationsList: action.payload,
        error: null,
      };
    case FETCH_LOCATIONS_LIST_FAILURE:
      return {
        ...state,
        isFetchingLocationsList: false,
        error: action.payload,
      };
    case SET_EDIT_LOCATION:
      return {
        ...state,
        isEditLocation: action.payload,
      };
    case SET_CURRENT_LOCATION:
      return {
        ...state,
        currentLocation: action.payload,
      };
    default:
      return state;
  }
};

export default locationReducer;
